<template>
  <section v-if="shouldRender" class="cta-section relative overflow-hidden section-padding">
    <div class="absolute inset-0 -z-10 opacity-20" style="background-image: radial-gradient(circle at 20% 20%, rgba(255,255,255,0.8) 0, transparent 40%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.5) 0, transparent 40%);"></div>
    <div class="container-full-width max-w-5xl rounded-[36px] border border-white/20 bg-white/5 px-8 py-14 text-center text-white shadow-2xl backdrop-blur">
      <span v-if="badge" class="inline-flex items-center justify-center rounded-full border border-white/30 px-4 py-1 text-sm font-medium uppercase tracking-[0.3em] text-white/80">{{ badge }}</span>
      <h2 v-if="ctaTitle" class="mt-6 text-3xl font-semibold leading-tight md:text-4xl">{{ ctaTitle }}</h2>
      <p v-if="ctaDescription" class="mt-4 text-base text-white/70 md:text-lg">
        {{ ctaDescription }}
      </p>
      <div class="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a v-if="primaryLabel" :href="primaryCtaUrl" class="primary-button primary-button--inverted">
          {{ primaryLabel }}
        </a>
        <button
          v-if="secondaryLabel"
          type="button"
          class="secondary-button border-white/40 text-white hover:border-white"
          @click="handleSecondaryClick"
        >
          {{ secondaryLabel }}
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  primaryCtaUrl: {
    type: String,
    required: true,
  },
  supportEmail: {
    type: String,
    required: true,
  },
  content: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['request-consultation']);

const sectionContent = computed(() => props.content || {});
const badge = computed(() => sectionContent.value.badge || '');
const ctaTitle = computed(() => sectionContent.value.title || '');
const ctaDescription = computed(() => sectionContent.value.description || '');
const primaryLabel = computed(() => sectionContent.value.primary_label || '');
const secondaryLabel = computed(() => sectionContent.value.secondary_label || '');
const shouldRender = computed(() => ctaTitle.value || ctaDescription.value || primaryLabel.value || secondaryLabel.value);

const handleSecondaryClick = () => {
  emit('request-consultation', 'cta-section');
};
</script>
